import { useMutation } from "@tanstack/react-query";
import {
  markActivityAsRead,
  MarkActivityAsReadResponse,
  markActivityAsUnread
} from "PFCore/services/marketplace/mutate_activity_read";
import { Id } from "PFTypes";
import { MutationOptions } from "PFTypes/request_options";

import { useActivitiesInvalidate } from "../use_activities_invalidate";

export const useMarketplaceMarkActivityAsRead = ({
  onSuccess,
  ...options
}: MutationOptions<Id, MarkActivityAsReadResponse> = {}) => {
  const { invalidateByCollection } = useActivitiesInvalidate();

  return useMutation<MarkActivityAsReadResponse, unknown, Id>({
    mutationFn: (activityId: Id) => markActivityAsRead(activityId),
    onSuccess: (...args) => {
      invalidateByCollection();
      onSuccess?.(...args);
    },
    ...options
  });
};

export const useMarketplaceMarkActivityAsUnread = ({ onSuccess, ...options }: MutationOptions<Id> = {}) => {
  const { invalidateByCollection } = useActivitiesInvalidate();

  return useMutation<void, unknown, Id>({
    mutationFn: (activityId: Id) => markActivityAsUnread(activityId),
    onSuccess: (...args) => {
      invalidateByCollection();
      onSuccess?.(...args);
    },
    ...options
  });
};
